package fr.labodoc.healthProfessional.api.payloads.responses

import fr.labodoc.domain.labodoc.common.NotificationFrequency
import kotlinx.datetime.Instant
import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class SelfResponse(
  val user: User
) {
  @Serializable
  data class User(
    val emailAddress: String,
    val lastLoginDate: Instant?,
    val rppsNumber: String?,
    val firstName: String,
    val lastName: String,
    val department: Department,
    val medicalProfession: MedicalProfession?,
    val medicalSpeciality: MedicalSpeciality?,
    val medicalInterests: List<MedicalInterest>,
    val canHaveMedicalInterests: Boolean,
    val professionalCategory: ProfessionalCategory,
    val professionalStatus: ProfessionalStatus?,
    val notificationFrequency: NotificationFrequency?
  ) {
    // Retrocompat
    val type: String = "fr.labodoc.api.payloads.responses.SelfResponse.User.HealthProfessional"

    @Serializable
    data class Department(
      val code: String,
      val name: String
    )

    @Serializable
    data class MedicalProfession(
      val id: String,
      val name: String
    )

    @Serializable
    data class MedicalSpeciality(
      val id: String,
      val name: String
    )

    @Serializable
    data class MedicalInterest(
      val id: String,
      val name: String
    )

    @Serializable
    data class ProfessionalCategory(
      val code: String,
      val name: String
    )

    @Serializable
    data class ProfessionalStatus(
      val code: String,
      val name: String
    )
  }
}
